// src/i18n.js
export const SECTION_TITLES = {
  en: {
    professionalSummary: 'PROFESSIONAL SUMMARY',
    areasOfExpertise:    'AREAS OF EXPERTISE',
    skills:              'SKILLS',
    languages:           'LANGUAGES',
    experience:          'PROFESSIONAL EXPERIENCE',
    education:           'EDUCATION',
  },
  de: {

   

    professionalSummary: 'BERUFSZUSAMMENFASSUNG',
    areasOfExpertise:    'EXPERTISE-BEREICHE',
    skills:              'FÄHIGKEITEN',
    languages:           'SPRACHEN',
    experience:          'BERUFSERFAHRUNG',
    education:           'AUSBILDUNG',
  },
  fr: {
  

    professionalSummary: 'RÉSUMÉ PROFESSIONNEL',
    areasOfExpertise:    'DOMAINES D’EXPERTISE',
    skills:              'COMPÉTENCES',
    languages:           'LANGUES',
    experience:          'EXPÉRIENCE PROFESSIONNELLE',
    education:           'FORMATION',
  },
  es: {
  

    professionalSummary: 'RESUMEN PROFESIONAL',
    areasOfExpertise:    'ÁREAS DE ESPECIALIDAD',
    skills:              'HABILIDADES',
    languages:           'IDIOMAS',
    experience:          'EXPERIENCIA PROFESIONAL',
    education:           'EDUCACIÓN',
  },
  it: {


    professionalSummary: 'SINTESI PROFESSIONALE',
    areasOfExpertise:    'AREE DI COMPETENZA',
    skills:              'COMPETENZE',
    languages:           'LINGUE',
    experience:          'ESPERIENZA PROFESSIONALE',
    education:           'ISTRUZIONE',

  },
};

// UI strings for the site (nav/buttons/labels/messages)
export const UI_STRINGS = {
  en: {


    tab_scan: "Free CV Scan",
    tab_match: "Tailor My CV to a Job (Free)",
    pricing_access_note: "30 days access • Cancel anytime",
pricing_secure_checkout: "Secure checkout with Stripe. No hidden fees.",

    cta_scan: "Get My Free CV Scan",
    cta_match: "Tailor My CV Now",
    nav_home: "Home",
    hint_secure: "Secure upload · Fast automated processing",

    preview_title: "Preview Your Results",
    preview_sub: "See how your CV becomes stronger, clearer, and more job-ready",
    preview_no: "Your preview will appear here.",
    preview_generating: "Generating your preview...",
    preview_loading: "Loading preview...",
    preview_error: "Preview could not be loaded.",
    preview_unlock: "Unlock My CV",
    preview_bottom: "Create stronger applications with unlimited CV and cover letter downloads.",

    video_badge: "45-second demo",
    video_title: "See your CV transformed in under a minute",
    video_desc:
      "Upload your CV, get an ATS scan, preview the improved version, and unlock your full CV.",
    video_unlock: "Boost your chances",
        // Premium CV Builder contact labels
    builder_contact_title: 'Contact details',
    builder_label_name: 'Name',
    builder_label_headline: 'Headline',
    builder_label_email: 'Email',
    builder_label_phone: 'Phone',
    builder_label_linkedin: 'LinkedIn',
    builder_label_location: 'Location (city & country)',
    builder_label_nationality: 'Nationality',

        // Premium CV Builder add/remove buttons
    builder_add_area: '+ Add area of expertise',
    builder_add_skill: '+ Add skill',
    builder_add_language: '+ Add language',
    builder_add_experience: '+ Add experience',
    builder_add_education: '+ Add education',
    builder_remove_experience: 'Remove experience',
    builder_remove_education: 'Remove education',

    // Premium CV Builder – experience & education labels
    builder_exp_role: 'Role',
    builder_exp_company: 'Company',
    builder_exp_location: 'Location',
    builder_exp_dates: 'Dates',
    builder_exp_dates_ph: 'e.g. 2019–2024',
    builder_exp_desc: 'Description / key achievements',
    nav_about: "About",
    builder_edu_degree: 'Degree / programme',
    builder_edu_institution: 'Institution',
    builder_edu_location: 'Location',
    builder_edu_dates: 'Dates',
    builder_edu_dates_ph: 'e.g. 2015–2018',


  
    nav_services: 'Services',
    nav_pricing: 'Pricing',
     nav_blog: 'Blog',
    nav_signin: 'Sign in',
    nav_signout: 'Sign out',

    label_site_lang: 'Language',
    label_cv_lang: 'CV Language',
    label_upload_cv: 'Upload your CV (PDF)',
    label_job_desc: 'Job description',
    label_credits: 'Credits',
    label_quota: 'Used / Monthly',

    btn_convert: 'Convert CV',
    btn_convert_match: 'Convert + Match JD',
    btn_build_from_scratch: 'Build CV',
    btn_download: 'Download',

    btn_download_cv: 'Download CV',
    btn_generate_cover: 'Generate your cover letter',
    btn_generate_cover_loading: 'Generating your cover letter...',
    btn_generate_your_cv:  'Generate Your CV', 

    msg_no_file: 'Please upload a PDF first.',
    msg_no_credits: 'No credits left. Please upgrade or wait for renewal.',
    msg_generated: 'Your file is ready.',
    field_email: 'Email',
    field_mobile: 'Mobile',
    field_linkedin: 'LinkedIn',
   
    
  
    nav_services: 'Services',
  

    
      // About
    about_title: 'About Us',
    about_paragraph: 'We’re CVBuilder Inc., dedicated to helping you present your best professional self. Our AI-powered tools automatically format, tailor, and build resumes that get you noticed.',

    // Services
    
    
    services_item1: 'ATS-Friendly CV Conversion – Turn any PDF resume into an ATS-optimized Word file.',
    services_item2: 'AI-Enhanced CV Matching – Tailor your CV’s keywords and bullets to any job posting.',
    services_item3: 'From-Scratch CV Builder – Create a brand-new, fully formatted CV from the ground up.',

    // Pricing
    pricing_title: 'Pricing',
    pricing_loading: 'Loading your plan...',
    pricing_current_plan: 'Your current plan:',
    pricing_no_plan: 'No Plan',
    pricing_active: '(active)',
    pricing_inactive: '(inactive)',
    pricing_manage: 'Manage subscription',
    pricing_col_plan: 'Plan',
    pricing_col_conversions: 'Conversions / 30 days',
    pricing_col_features: 'Features',
    pricing_col_price: 'Price',
    pricing_feat_standard: 'ATS-friendly CV conversions',
    pricing_feat_advanced: 'ATS-friendly + AI matching + JD refinement',
    pricing_feat_premium: 'All services (ATS + AI + JD)',
    pricing_subscribe: "Create My CV Now",
    pricing_current: 'Current',
    feature_ats: 'ATS-Friendly CV Conversion',
    feature_ai: 'AI-Enhanced CV Matching',
    feature_builder: 'From-Scratch CV Builder',
    credits_left: '{count} credits left',
    pricing_recharge: "Recharge Now",
    credits_none: "You’ve reached your Fair Use limit for normal personal use. Recharge now to continue instantly.",
    pricing_cancel_anytime: "You can cancel at any time.",
    pricing_fair_use_title: "Fair Use Policy:",
  pricing_fair_use_body:"All plans include unlimited AI usage for normal personal use. To keep the service fast and reliable for everyone, heavy or automated commercial use may be temporarily limited.",
 pricing_legal_intro: "By purchasing access, you agree to our",
  pricing_legal_terms: "Terms",
  pricing_legal_and: "and",
  pricing_legal_privacy: "Privacy",

    // Add under UI_STRINGS.en:
hero_title: "Improve Your CV in 30 Seconds and Get More Interviews",
hero_sub: "Upload your CV and get a free instant scan plus a preview of your improved CV.",
hero_upload_label: "Upload Your CV (PDF):",
btn_scan: "Scan My CV",
btn_scanning: "Scanning…",

per_month: "month",
btn_get_started: "Get Started",
badge_gdpr: "GDPR COMPLIANT",
badge_secure: "SECURE PAYMENTS",

card_ats_title: "Smart CV Conversion",
card_ats_desc: "Convert your CV into a format that passes HR tracking systems (ATS) and is easy for recruiters to review.",
card_ai_title: "AI-Enhanced CV Matching",

card_ai_desc: "Match your CV and cover letter to any job offer with AI and boost your chances of getting interviews.",
card_builder_title: "Premium CV Builder",
card_builder_desc: "Create a complete, modern CV and cover letter in minutes, powered by AI to help you stand out and land your next job.",


plan_ats_feature1: "Automatic CV upgrade",
plan_ats_feature2: "Instant results, no manual editing",
plan_ats_feature3: "Available in 5 languages",
plan_ats_feature4: "Unlimited downloads",

plan_ai_feature1: "Automatic CV upgrade",
plan_ai_feature2: "AI job-description matching",
plan_ai_feature3: "AI keyword optimization",
plan_ai_feature4: "Cover letter generator",
plan_ai_feature5: "Available in 5 languages",
plan_ai_feature6: "Unlimited downloads",

plan_builder_feature1: "AI builds your CV from scratch",
plan_builder_feature2: "Optimized for HR tracking systems",
plan_builder_feature3: "AI job-description matching",
plan_builder_feature4: "AI keyword optimization",
plan_builder_feature5: "Cover letter generator",
plan_builder_feature6: "Available in 5 languages",
plan_builder_feature7: "Unlimited downloads",

why_title: "Why Choose Us?",
why_ats_title: "Pass HR Tracking (ATS)",
why_ats_desc: "Your CV is rebuilt to pass HR tracking systems (ATS).",
why_ai_title: "AI Matching",
why_ai_desc: "Our AI matches your CV to any job offer and adds the right skills",
why_easy_title: "Easy to Use",
why_easy_desc: "Simple process: upload, scan and download.",
why_formats_title: "Compatible Formats",
why_formats_desc: "Professional CV, ready to send in 5 languages.",

trusted_by: "Get your CV ready for top companies" ,
ats_title: "Pass ATS filters with AI",
ats_sub: "We scan your CV the same way an Applicant Tracking System (ATS) does, then help you fix it so real recruiters actually see it.",

ats_item1_title: "What is an ATS?",
ats_item1_desc: "An ATS is the software that checks your CV before a human does. It looks at keywords, job titles and basic structure to decide who moves forward.",

ats_item2_title: "Why CVs get rejected",
ats_item2_desc: "Missing keywords, unclear titles, date gaps or over-designed layouts can cause your CV to be filtered out automatically, even if you’re a great fit.",

ats_item3_title: "How YourSmartCV helps",
ats_item3_desc: "We analyse your CV, clean the structure and add the right keywords so ATS systems recognise you as a strong match for the role.",

ats_item4_title: "Get recruiter-ready",
ats_item4_desc: "Export a clean, recruiter-ready PDF that passes ATS checks and is easy for hiring managers to review in seconds.",

ats_testimonial_title: "What users say",
btn_use_service: 'Use this service',



 about_brand_name: "YourSmartCV",
 
  about_intro_1_rest:
    "is a website and companion app built by Ly Insights in Berlin, Germany. We use AI to turn any CV into a complete, ready-to-use PDF that passes HR screening systems (ATS) and is easy for recruiters to read.",
  about_intro_2_part1:
    "Whether you’re applying for local or international roles, YourSmartCV works in",
 about_intro_2_languages:
    "five languages: English, French, German, Italian, and Spanish",

  about_intro_2_part2:  "so you can reach more opportunities without rewriting everything from scratch.",
  about_block_ats_title: "Smart CV Conversion",
  about_block_ats_body:"Upload any CV in PDF (even messy or non-standard) and get back a clean, structured CV that goes smoothly through HR screening systems (ATS) and looks professional to recruiters.",

  about_block_ai_title: "AI-Enhanced CV Matching",
  about_block_ai_body:
    "Match your CV to any job offer and boost your chances of getting interviews. Upload your CV, paste the job description, and receive a complete, ready-to-use CV rebuilt with structure and keywords aligned to what HR screening systems (ATS) and recruiters are looking for.",

  about_block_builder_title: "Premium CV Builder",
  about_block_builder_body:
    "Start from zero and let our AI build your CV step by step. Then match it to specific job descriptions to create targeted versions in minutes – helping you stand out and land your next job.",

  about_block_free_title: "Free CV Scan",
  about_block_free_body:
    "Upload your CV and instantly see how well it would perform in HR tracking systems (ATS). If you want a stronger CV, you can upgrade to one of the three paid services in a few clicks.",

  about_mission_bold: "Our mission is simple:",
  about_mission_rest:
  " make professional, recruiter-ready CVs fast and stress-free for everyone, in one place, in five languages.",

  about_contact_title: "Contact:",
  about_contact_email_label: "Email:",
  about_address_title: "Business Address:",


  services_title: "Your AI CV Workspace",
  services_subtitle: "Use your tools below to create professional, recruiter-ready CVs in minutes.",


  services_ats_desc:
    "Convert any CV into a clean, professional format that passes HR tracking systems (ATS) and is easy for recruiters to read.",

  services_ai_desc:
    "Match your CV and cover letter to any job offer with AI and increase your chances of getting interviews.",

  services_builder_desc:
    "Build your CV and cover letter from scratch with AI and instantly generate professional, refined versions in minutes.",

    // Free ATS scan result
    ats_result_title: "Your CV score: {score}% ({level})",
    ats_result_default_reason:
      "At this level, HR tracking systems (ATS) may not read your CV correctly, which means a high risk of automatic rejection before a recruiter sees it.",
    ats_result_boost_cta:
      "Boost your CV in minutes with our AI tools.",
    ats_result_button: "Improve My CV Now",
    ats_level_low: "Low",
    ats_level_medium: "Medium",
    ats_level_high: "High",

    // Free scan credit
    btn_scan_used: "Free scan used",
    free_scan_used:"You’ve already used your free ATS scan on this device. To scan or improve more CVs, please choose one of our plans.",
    


          // ATS score descriptions (hero free scan card)
 ats_desc_low:
  "The software many companies use to filter CVs (ATS) struggles to read your CV, so many of your applications may be rejected before a recruiter has a chance to review it.",
ats_desc_medium:
  "The software companies use to pre-filter CVs (ATS) only understands part of your CV, so your profile often stays hidden instead of appearing in searches and shortlists.",

ats_desc_high:
  "The HR tracking software many employers use (ATS) can read your CV, but it isn’t fully optimised for structure and keywords, so stronger competitors may still outrank you for the same jobs.",
 

    blog_title: 'YourSmartCV Career Guides',
    blog_intro: 'Step-by-step guides on ATS, German job applications, and CV strategy.',
    blog_published_on: 'Published',
    blog_read_time: 'read',
    blog_subtitle: 'Practical, ATS-aware advice to help you write smarter CVs, tailor applications with AI, and get closer to the interviews you want',
    blog_read_more :'Read More',
    blog_back : 'Back To Blog',
    testimonial_1_text: "This is the best tool I’ve used for emailing a professional CV. The AI matching is incredibly accurate.",
    testimonial_1_author: "Thomas M.",

    testimonial_2_text: "My CV score jumped instantly. I went from being ignored to getting 4 interviews.",
    testimonial_2_author: "Sarah M.",

    testimonial_3_text: "Finally a tool that explains what the ATS wants. Super simple and super helpful.",
    testimonial_3_author: "Daniel K."

  },
  fr: {

    tab_scan: "Analyser mon CV gratuitement",
    tab_match: "Adapter mon CV à une offre (Gratuit)",
    pricing_access_note: "Accès 30 jours • Annulation à tout moment",
pricing_secure_checkout: "Paiement sécurisé avec Stripe. Aucun frais caché.",

    cta_scan: "Analyser mon CV gratuitement",
    cta_match: "Adapter mon CV gratuitement",
    preview_generating: "Génération de votre aperçu...",
    preview_loading: "Chargement de l’aperçu...",
    preview_error: "L’aperçu n’a pas pu être chargé.",

    hint_secure: "Téléchargement sécurisé · Traitement rapide et automatique",

    preview_title: "Aperçu de vos résultats",
    preview_sub: "Découvrez un CV plus clair, plus convaincant et mieux adapté au poste visé",
    preview_no: "Votre aperçu s’affichera ici.",
    preview_unlock: "Télécharger mon CV",
    preview_bottom: "Créez des candidatures plus percutantes avec des téléchargements illimités de CV et de lettres de motivation.",

    video_badge: "Démo en 45 secondes",
    video_title: "Découvrez comment améliorer votre CV en moins d’une minute",
    video_desc:
      "Importez votre CV, obtenez une analyse ATS, prévisualisez la version optimisée et récupérez instantanément votre CV.",
    video_unlock: "Boostez vos chances",

  // Premium CV Builder contact labels
  builder_contact_title: "Coordonnées",
  builder_label_name: "Nom",
  builder_label_headline: "Titre du profil",
  builder_label_email: "E-mail",
  builder_label_phone: "Téléphone",
  builder_label_linkedin: "LinkedIn",
  builder_label_location: "Localisation (ville et pays)",
  builder_label_nationality: "Nationalité",

  // Premium CV Builder add/remove buttons
  builder_add_area: "+ Ajouter un domaine d’expertise",
  builder_add_skill: "+ Ajouter une compétence",
  builder_add_language: "+ Ajouter une langue",
  builder_add_experience: "+ Ajouter une expérience",
  builder_add_education: "+ Ajouter une formation",
  builder_remove_experience: "Supprimer l’expérience",
  builder_remove_education: "Supprimer la formation",

  // Premium CV Builder – experience & education labels
  builder_exp_role: "Poste",
  builder_exp_company: "Entreprise",
  builder_exp_location: "Lieu",
  builder_exp_dates: "Période",
  builder_exp_dates_ph: "ex. 2019–2024",
  builder_exp_desc: "Description / réalisations clés",

  builder_edu_degree: "Diplôme / programme",
  builder_edu_institution: "Établissement",
  builder_edu_location: "Lieu",
  builder_edu_dates: "Période",
  builder_edu_dates_ph: "ex. 2015–2018",

  nav_home: "Accueil",
  nav_services: "Services",
  nav_pricing: "Tarifs",
  nav_blog: "Blog",
  nav_signin: "Se connecter",
  nav_signout: "Se déconnecter",

  label_site_lang: "Langue du site",
  label_cv_lang: "Langue du CV",
  label_upload_cv: "Importez votre CV (PDF)",
  label_job_desc: "Description du poste",
  label_credits: "Crédits",
  label_quota: "Utilisé / mois",

  btn_convert: "Convertir le CV",
  btn_convert_match: "Convertir + adapter à l’offre",
  btn_build_from_scratch: "Créer un CV",
  btn_download: "Télécharger",

  btn_download_cv: "Télécharger le CV",
  btn_generate_cover: "Générer votre lettre de motivation",
  btn_generate_cover_loading: "Génération de votre lettre de motivation…",
  btn_generate_your_cv: "Générer votre CV",

  msg_no_file: "Veuillez d’abord importer un fichier PDF.",
  msg_no_credits: "Plus de crédits disponibles. Veuillez mettre à niveau votre offre ou attendre le renouvellement.",
  msg_generated: "Votre fichier est prêt.",
  field_email: "E-mail",
  field_mobile: "Mobile",
  field_linkedin: "LinkedIn",
  nav_about: "À propos",
  // (nav_* repeated)
  nav_signin: "Se connecter",
  nav_signout: "Se déconnecter",

  // About
  about_title: "À propos de nous",
  about_paragraph:
    "Nous sommes CVBuilder Inc., dédiés à vous aider à présenter la meilleure version professionnelle de vous-même. Nos outils basés sur l’IA mettent automatiquement votre CV en forme, l’adaptent et le construisent pour vous aider à vous faire remarquer.",

  // Services (first block)
  
  
  services_item1:
    "Conversion de CV compatible ATS – Transformez n’importe quel CV en PDF en fichier Word optimisé pour les systèmes de suivi des candidatures (ATS).",
  services_item2:
    "Mise en correspondance de CV améliorée par l’IA – Adaptez les mots-clés et les puces de votre CV à n’importe quelle offre d’emploi.",
  services_item3:
    "Créateur de CV à partir de zéro – Créez un CV entièrement formaté depuis une page blanche.",

  // Pricing
  pricing_title: "Tarifs",
  pricing_loading: "Chargement de votre offre…",
  pricing_current_plan: "Votre offre actuelle :",
  pricing_no_plan: "Aucune offre",
  pricing_active: "(actif)",
  pricing_inactive: "(inactif)",
  pricing_manage: "Gérer l’abonnement",
  pricing_col_plan: "Offre",
  pricing_col_conversions: "Conversions / 30 jours",
  pricing_col_features: "Fonctionnalités",
  pricing_col_price: "Prix",
  pricing_feat_standard: "Conversions de CV compatibles ATS",
  pricing_feat_advanced: "CV compatible ATS + mise en correspondance IA + optimisation de la description de poste",
  pricing_feat_premium: "Tous les services (ATS + IA + description de poste)",
  pricing_subscribe: "Créer mon CV maintenant",
  pricing_current: "Actuel",
  feature_ats: "Conversion de CV compatible ATS",
  feature_ai: "Mise en correspondance de CV par IA",
  feature_builder: "Créateur de CV à partir de zéro",
  credits_left: "Il vous reste {count} crédits",
  credits_none: "Vous avez atteint votre limite d’utilisation équitable pour un usage personnel normal. Rechargez maintenant pour continuer immédiatement.",
  pricing_recharge: "Recharger maintenant",
  pricing_cancel_anytime: "Vous pouvez annuler à tout moment.",
  pricing_fair_use_title: "Politique d’utilisation équitable :",
  pricing_fair_use_body:
    "Tous les forfaits incluent une utilisation illimitée de l’IA pour un usage personnel normal. Afin de garder le service rapide et fiable pour tout le monde, une utilisation intensive ou automatisée à des fins commerciales peut être limitée temporairement.",
  pricing_legal_intro: "En achetant l’accès, vous acceptez nos",
  pricing_legal_terms: "Conditions",
  pricing_legal_and: "et notre",
  pricing_legal_privacy: "Politique de confidentialité",

  // Hero
  hero_title: "Améliorez votre CV en 30 secondes et obtenez plus d’entretiens",
  hero_sub: "Téléchargez votre CV et obtenez une analyse gratuite instantanée, ainsi qu’un aperçu de votre CV amélioré.",
  hero_upload_label: "Importez votre CV (PDF) :",
  btn_scan: "Analyser mon CV",
  btn_scanning: "Analyse en cours…",

  per_month: "mois",
  btn_get_started: "Commencer",
  badge_gdpr: "CONFORME RGPD",
  badge_secure: "PAIEMENTS SÉCURISÉS",

  card_ats_title: "Smart CV Conversion",
  card_ats_desc:
    "Convertissez votre CV dans un format qui passe les systèmes de suivi des candidatures (ATS) et reste facile à lire pour les recruteurs.",
  card_ai_title: "AI-Enhanced CV Matching",
  
  card_builder_title: "Premium CV Builder",
  

card_ai_desc: "Faites correspondre votre CV et votre lettre de motivation à n’importe quelle offre grâce à l’IA et augmentez vos chances d’obtenir des entretiens.",
card_builder_desc: "Créez en quelques minutes un CV et une lettre de motivation complets et modernes, propulsés par l’IA pour vous aider à vous démarquer et décrocher votre prochain poste.",

  plan_ats_feature1: "Mise à niveau automatique du CV",
  plan_ats_feature2: "Résultats instantanés, sans retouche manuelle",
  plan_ats_feature3: "Disponible en 5 langues",
  plan_ats_feature4: "Téléchargements illimités",

  plan_ai_feature1: "Mise à niveau automatique du CV",
  plan_ai_feature2: "Correspondance IA avec la description de poste",
  plan_ai_feature3: "Optimisation des mots-clés par l’IA",
  plan_ai_feature4: "Générateur de lettre de motivation",
  plan_ai_feature5: "Disponible en 5 langues",
  plan_ai_feature6: "Téléchargements illimités",

  plan_builder_feature1: "L’IA crée votre CV à partir de zéro",
  plan_builder_feature2: "Optimisé pour les systèmes de suivi des candidatures",
  plan_builder_feature3: "Correspondance IA avec la description de poste",
  plan_builder_feature4: "Optimisation des mots-clés par l’IA",
  plan_builder_feature5: "Générateur de lettre de motivation",
  plan_builder_feature6: "Disponible en 5 langues",
  plan_builder_feature7: "Téléchargements illimités",

  why_title: "Pourquoi nous choisir ?",
  why_ats_title: "Passer les filtres RH (ATS)",
  why_ats_desc: "Votre CV est reconstruit pour passer les systèmes de suivi des candidatures (ATS).",
  why_ai_title: "Mise en correspondance IA",
  why_ai_desc: "Notre IA fait correspondre votre CV à n’importe quelle offre et ajoute les bonnes compétences.",
  why_easy_title: "Simple à utiliser",
  why_easy_desc: "Processus simple : importez, analysez et téléchargez.",
  why_formats_title: "Formats compatibles",
  why_formats_desc: "CV professionnel prêt à être envoyé en 5 langues.",

  trusted_by: "Préparez votre CV pour les plus grandes entreprises",
  ats_title: "Passer les filtres ATS avec l’IA",
  ats_sub:
    "Nous analysons votre CV comme le ferait un système de suivi des candidatures (ATS), puis nous vous aidons à le corriger pour que de vrais recruteurs le voient.",

  ats_item1_title: "Qu’est-ce qu’un ATS ?",
  ats_item1_desc:
    "Un ATS est un logiciel qui vérifie votre CV avant un humain. Il examine les mots-clés, les intitulés de poste et la structure pour décider qui passe à l’étape suivante.",

  ats_item2_title: "Pourquoi les CV sont rejetés",
  ats_item2_desc:
    "L’absence de mots-clés, des titres peu clairs, des trous dans les dates ou une mise en page trop graphique peuvent faire que votre CV soit filtré automatiquement, même si votre profil est pertinent.",

  ats_item3_title: "Comment YourSmartCV vous aide",
  ats_item3_desc:
    "Nous analysons votre CV, nettoyons la structure et ajoutons les bons mots-clés afin que les systèmes ATS vous reconnaissent comme un bon candidat pour le poste.",

  ats_item4_title: "Prêt pour les recruteurs",
  ats_item4_desc:
    "Exportez un PDF clair, prêt pour les recruteurs, qui passe les contrôles ATS et se lit en quelques secondes.",

  ats_testimonial_title: "Ce que disent les utilisateurs",
  btn_use_service: "Utiliser ce service",

  // About YourSmartCV (second block)
 
  
  about_brand_name: "YourSmartCV",

  about_intro_1_rest:
    "est un site web et une application compagnon créés par Ly Insights à Berlin, en Allemagne. Nous utilisons l’IA pour transformer n’importe quel CV en un PDF complet et prêt à l’emploi qui passe les systèmes de présélection RH (ATS) et reste facile à lire pour les recruteurs.",
  about_intro_2_part1:
    "Que vous postuliez pour des postes locaux ou internationaux, YourSmartCV fonctionne en",
  about_intro_2_languages:
    "cinq langues : anglais, français, allemand, italien et espagnol",
  about_intro_2_part2:
    "afin que vous puissiez viser plus d’opportunités sans tout réécrire depuis le début.",
  about_block_ats_title: "Smart CV Conversion",
  about_block_ats_body:
    "Importez n’importe quel CV en PDF (même désordonné ou non standard) et récupérez un CV propre, structuré, qui passe sans problème les systèmes de présélection RH (ATS) et qui a l’air professionnel pour les recruteurs.",
  about_block_ai_title: "AI-Enhanced CV Matching",
  about_block_ai_body:
    "Faites correspondre votre CV à n’importe quelle offre d’emploi et augmentez vos chances d’obtenir des entretiens. Importez votre CV, collez la description de poste et recevez un CV complet et prêt à l’emploi, reconstruit avec une structure et des mots-clés alignés sur ce que recherchent les systèmes ATS et les recruteurs.",
  about_block_builder_title: "Premium CV Builder",
  about_block_builder_body:
    "Partez de zéro et laissez notre IA construire votre CV étape par étape. Adaptez-le ensuite à des offres spécifiques pour créer des versions ciblées en quelques minutes – de quoi vous aider à vous démarquer et décrocher votre prochain poste.",
  about_block_free_title: "Analyse de CV gratuite",
  about_block_free_body:
    "Importez votre CV et voyez instantanément comment il se comporterait dans les systèmes de suivi des candidatures (ATS). Si vous souhaitez un CV plus fort, vous pouvez passer à l’un de nos trois services payants en quelques clics.",
  about_mission_bold: "Notre mission est simple :",
  about_mission_rest:
    " rendre les CV professionnels, prêts pour les recruteurs, rapides et sans stress pour tout le monde, en un seul endroit et en cinq langues.",
  about_contact_title: "Contact :",
  about_contact_email_label: "E-mail :",
  about_address_title: "Adresse professionnelle :",


  // Services (workspace)
  services_title: "Votre espace CV avec IA",
  services_subtitle:
    "Utilisez les outils ci-dessous pour créer des CV professionnels, prêts pour les recruteurs, en quelques minutes.",

  services_ats_desc:
    "Convertissez n’importe quel CV en un format propre et professionnel qui passe les systèmes de suivi des candidatures (ATS) et reste facile à lire pour les recruteurs.",
  services_ai_desc:
    "Faites correspondre votre CV et votre lettre de motivation à n’importe quelle offre d’emploi grâce à l’IA et augmentez vos chances d’obtenir des entretiens.",
  services_builder_desc:
    "Créez votre CV et votre lettre de motivation à partir de zéro avec l’IA et générez instantanément des versions professionnelles et soignées.",

  // Free ATS scan result
  ats_result_title: "Score de votre CV : {score}% ({level})",
  ats_result_default_reason:
    "À ce niveau, les systèmes de suivi des candidatures (ATS) risquent de ne pas lire correctement votre CV, ce qui signifie un risque élevé de rejet automatique avant qu’un recruteur ne le voie.",
  ats_result_boost_cta:
    "Améliorez votre CV en quelques minutes avec nos outils d’IA.",
  ats_result_button: "Améliorer mon CV maintenant",
  ats_level_low: "Faible",
  ats_level_medium: "Moyen",
  ats_level_high: "Élevé",

  // Free scan credit
  btn_scan_used: "Analyse gratuite utilisée",
  free_scan_used:
    "Vous avez déjà utilisé votre analyse ATS gratuite sur cet appareil. Pour analyser ou améliorer d’autres CV, veuillez choisir l’une de nos offres.",

  

  // ATS score descriptions (hero free scan card)
  ats_desc_low:
    "Le logiciel que de nombreuses entreprises utilisent pour filtrer les CV (ATS) a du mal à lire votre CV, donc beaucoup de vos candidatures peuvent être rejetées avant même qu’un recruteur ne le voie.",
  ats_desc_medium:
    "Le logiciel que les entreprises utilisent pour pré-filtrer les CV (ATS) ne comprend qu’une partie de votre CV, donc votre profil reste souvent caché au lieu d’apparaître dans les recherches et les présélections.",
  ats_desc_high:
    "Le logiciel de suivi des candidatures (ATS) que de nombreux employeurs utilisent peut lire votre CV, mais il n’est pas entièrement optimisé en termes de structure et de mots-clés, donc des candidats mieux optimisés peuvent encore vous devancer sur les mêmes postes.",

  // Blog
  blog_title: "Guides de carrière YourSmartCV",
  blog_intro:
    "Des guides pas à pas sur les ATS, les candidatures en Allemagne et la stratégie de CV.",
  blog_published_on: "Publié le",
  blog_read_time: "de lecture",
  blog_subtitle:
    "Des conseils pratiques, compatibles ATS, pour rédiger des CV plus intelligents, adapter vos candidatures avec l’IA et vous rapprocher des entretiens que vous visez",
  blog_read_more: "Lire la suite",
  testimonial_1_text: "C’est le meilleur outil que j’ai utilisé pour créer un CV professionnel. Le matching par IA est incroyablement précis.",
testimonial_1_author: "Thomas M.",

testimonial_2_text: "Mon score CV a augmenté immédiatement. Je suis passée de candidatures ignorées à 4 entretiens.",
testimonial_2_author: "Sarah M.",

testimonial_3_text: "Enfin un outil qui explique ce que les systèmes ATS attendent. Très simple et très utile.",
testimonial_3_author: "Daniel K.",
  blog_back: "Retour au blog"
},
de: {

tab_scan: "Meinen Lebenslauf kostenlos prüfen",
tab_match: "Meinen Lebenslauf kostenlos an einen Job anpassen",
pricing_access_note: "30 Tage Zugang • Jederzeit kündbar",
pricing_secure_checkout: "Sichere Zahlung mit Stripe. Keine versteckten Gebühren.",
preview_generating: "Ihre Vorschau wird erstellt...",
preview_loading: "Vorschau wird geladen...",
preview_error: "Die Vorschau konnte nicht geladen werden.",
cta_scan: "Meinen Lebenslauf kostenlos prüfen",
cta_match: "Meinen Lebenslauf kostenlos anpassen",

hint_secure: "Sicherer Upload · Schnell und automatisch verarbeitet",

preview_title: "Ihre Vorschau",
preview_sub: "Sehen Sie, wie Ihr Lebenslauf klarer, überzeugender und passender für den Job wird",
preview_no: "Ihre Vorschau erscheint hier.",
preview_unlock: "Meinen Lebenslauf herunterladen",
preview_bottom: "Erstellen Sie stärkere Bewerbungen mit unbegrenzten Downloads von Lebensläufen und Anschreiben.",

video_badge: "45-Sekunden-Demo",
video_title: "Sehen Sie in weniger als einer Minute, wie Ihr Lebenslauf verbessert wird",
video_desc:
  "Laden Sie Ihren Lebenslauf hoch, erhalten Sie einen ATS-Check, sehen Sie sich die optimierte Version an und laden Sie Ihren Lebenslauf sofort herunter.",
video_unlock: "Jetzt bessere Chancen sichern",

  // Premium CV Builder contact labels
  builder_contact_title: "Kontaktdaten",
  builder_label_name: "Name",
  builder_label_headline: "Beruflicher Titel",
  builder_label_email: "E-Mail",
  builder_label_phone: "Telefon",
  builder_label_linkedin: "LinkedIn",
  builder_label_location: "Ort (Stadt und Land)",
  builder_label_nationality: "Staatsangehörigkeit",

  // Premium CV Builder add/remove buttons
  builder_add_area: "+ Fachgebiet hinzufügen",
  builder_add_skill: "+ Kompetenz hinzufügen",
  builder_add_language: "+ Sprache hinzufügen",
  builder_add_experience: "+ Berufserfahrung hinzufügen",
  builder_add_education: "+ Ausbildung hinzufügen",
  builder_remove_experience: "Berufserfahrung entfernen",
  builder_remove_education: "Ausbildung entfernen",

  // Premium CV Builder – experience & education labels
  builder_exp_role: "Position",
  builder_exp_company: "Unternehmen",
  builder_exp_location: "Ort",
  builder_exp_dates: "Zeitraum",
  builder_exp_dates_ph: "z. B. 2019–2024",
  builder_exp_desc: "Beschreibung / wichtigste Erfolge",

  builder_edu_degree: "Abschluss / Studiengang",
  builder_edu_institution: "Institution",
  builder_edu_location: "Ort",
  builder_edu_dates: "Zeitraum",
  builder_edu_dates_ph: "z. B. 2015–2018",

  nav_home: "Startseite",
  nav_services: "Leistungen",
  nav_pricing: "Preise",
  nav_blog: "Blog",
  nav_signin: "Anmelden",
  nav_signout: "Abmelden",

  label_site_lang: "Sprache der Website",
  label_cv_lang: "CV-Sprache",
  label_upload_cv: "Lebenslauf (PDF) hochladen",
  label_job_desc: "Stellenbeschreibung",
  label_credits: "Guthaben",
  label_quota: "Verbraucht / Monat",

  btn_convert: "CV konvertieren",
  btn_convert_match: "Konvertieren + mit Stelle abgleichen",
  btn_build_from_scratch: "CV erstellen",
  btn_download: "Download",

  btn_download_cv: "CV herunterladen",
  btn_generate_cover: "Anschreiben erstellen",
  btn_generate_cover_loading: "Anschreiben wird erstellt…",
  btn_generate_your_cv: "CV erstellen",

  msg_no_file: "Bitte laden Sie zuerst eine PDF-Datei hoch.",
  msg_no_credits:
    "Kein Guthaben mehr vorhanden. Bitte upgraden Sie oder warten Sie auf die Verlängerung.",
  msg_generated: "Ihre Datei ist fertig.",
  field_email: "E-Mail",
  field_mobile: "Mobiltelefon",
  field_linkedin: "LinkedIn",
  nav_about: "Über uns",
  nav_signin: "Anmelden",
  nav_signout: "Abmelden",

  // About
  about_title: "Über uns",
  about_paragraph:
    "Wir sind CVBuilder Inc. und helfen Ihnen dabei, sich beruflich von Ihrer besten Seite zu zeigen. Unsere KI-gestützten Tools formatieren, personalisieren und erstellen Ihren Lebenslauf automatisch, damit Sie auffallen.",

  // Services (first block)
 
  
  services_item1:
    "ATS-freundliche CV-Konvertierung – Wandeln Sie jeden PDF-Lebenslauf in eine ATS-optimierte Word-Datei um.",
  services_item2:
    "KI-gestütztes CV-Matching – Passen Sie die Stichwörter und Aufzählungspunkte Ihres CVs an jede Stellenausschreibung an.",
  services_item3:
    "CV-Erstellung von Grund auf – Erstellen Sie einen komplett formatierten Lebenslauf von null an.",

  // Pricing
  pricing_title: "Preise",
  pricing_loading: "Ihr Tarif wird geladen…",
  pricing_current_plan: "Ihr aktueller Tarif:",
  pricing_no_plan: "Kein Tarif",
  pricing_active: "(aktiv)",
  pricing_inactive: "(inaktiv)",
  pricing_manage: "Abonnement verwalten",
  pricing_col_plan: "Tarif",
  pricing_col_conversions: "Konvertierungen / 30 Tage",
  pricing_col_features: "Funktionen",
  pricing_col_price: "Preis",
  pricing_feat_standard: "ATS-freundliche CV-Konvertierungen",
  pricing_feat_advanced:
    "ATS-freundlich + KI-Matching + Optimierung der Stellenbeschreibung",
  pricing_feat_premium: "Alle Dienste (ATS + KI + Stellenbeschreibung)",
  pricing_subscribe: "Meinen CV jetzt erstellen",
  pricing_current: "Aktuell",
  feature_ats: "ATS-freundliche CV-Konvertierung",
  feature_ai: "KI-gestütztes CV-Matching",
  feature_builder: "CV-Erstellung von Grund auf",
  credits_left: "{count} Guthaben übrig",
  pricing_recharge: "Jetzt aufladen",
  credits_none: "Sie haben Ihr Fair-Use-Limit für normale private Nutzung erreicht. Laden Sie jetzt auf, um sofort weiterzumachen.",
  pricing_cancel_anytime: "Sie können jederzeit kündigen.",
  pricing_fair_use_title: "Fair-Use-Richtlinie:",
  pricing_fair_use_body:
    "Alle Tarife beinhalten eine unbegrenzte KI-Nutzung für normale private Zwecke. Um den Dienst für alle schnell und stabil zu halten, kann eine intensive oder automatisierte kommerzielle Nutzung vorübergehend eingeschränkt werden.",
  pricing_legal_intro: "Mit dem Kauf des Zugangs stimmen Sie unseren",
  pricing_legal_terms: "Nutzungsbedingungen",
  pricing_legal_and: "und unserer",
  pricing_legal_privacy: "Datenschutzerklärung zu.",

  // Hero
  hero_title: "Verbessere deinen Lebenslauf in 30 Sekunden und bekomme mehr Vorstellungsgespräche",
  hero_sub: "Lade deinen Lebenslauf hoch und erhalte einen kostenlosen Sofort-Check plus eine Vorschau deines verbesserten Lebenslaufs.",
  hero_upload_label: "Lebenslauf (PDF) hochladen:",
  btn_scan: "Meinen CV scannen",
  btn_scanning: "Scan läuft…",

  per_month: "Monat",
  btn_get_started: "Jetzt starten",
  badge_gdpr: "DSGVO-KONFORM",
  badge_secure: "SICHERE ZAHLUNGEN",

  card_ats_title: "Smart CV Conversion",
  card_ats_desc:
    "Konvertieren Sie Ihren CV in ein Format, das Bewerbermanagement systeme (ATS) passieren kann und für Recruiter leicht zu lesen ist.",
  card_ai_title: "AI-Enhanced CV Matching",
  
  card_builder_title: "Premium CV Builder",
  card_ai_desc: "Gleichen Sie Ihren CV und Ihr Anschreiben mit KI an jede Stellenausschreibung an und erhöhen Sie Ihre Chancen auf Vorstellungsgespräche.",
card_builder_desc: "Erstellen Sie in wenigen Minuten einen vollständigen, modernen CV und ein Anschreiben – unterstützt durch KI, damit Sie auffallen und Ihren nächsten Job bekommen.",

  plan_ats_feature1: "Automatische CV-Optimierung",
  plan_ats_feature2: "Sofortige Ergebnisse, kein manuelles Bearbeiten",
  plan_ats_feature3: "Verfügbar in 5 Sprachen",
  plan_ats_feature4: "Unbegrenzte Downloads",

  plan_ai_feature1: "Automatische CV-Optimierung",
  plan_ai_feature2: "KI-Abgleich mit Stellenbeschreibung",
  plan_ai_feature3: "KI-gestützte Keyword-Optimierung",
  plan_ai_feature4: "Anschreiben-Generator",
  plan_ai_feature5: "Verfügbar in 5 Sprachen",
  plan_ai_feature6: "Unbegrenzte Downloads",

  plan_builder_feature1: "KI erstellt Ihren CV von Grund auf",
  plan_builder_feature2: "Optimiert für Bewerbermanagement systeme",
  plan_builder_feature3: "KI-Abgleich mit Stellenbeschreibung",
  plan_builder_feature4: "KI-gestützte Keyword-Optimierung",
  plan_builder_feature5: "Anschreiben-Generator",
  plan_builder_feature6: "Verfügbar in 5 Sprachen",
  plan_builder_feature7: "Unbegrenzte Downloads",

  why_title: "Warum wir?",
  why_ats_title: "ATS-Filter bestehen",
  why_ats_desc:
    "Ihr CV wird so neu aufgebaut, dass er Bewerbermanagement systeme (ATS) passieren kann.",
  why_ai_title: "KI-Matching",
  why_ai_desc:
    "Unsere KI gleicht Ihren CV mit jeder Stellenausschreibung ab und fügt die passenden Fähigkeiten hinzu.",
  why_easy_title: "Einfach zu bedienen",
  why_easy_desc: "Einfacher Ablauf: hochladen, scannen, herunterladen.",
  why_formats_title: "Kompatible Formate",
  why_formats_desc:
    "Professioneller Lebenslauf, versandfertig in 5 Sprachen.",

  trusted_by: "Machen Sie Ihren CV fit für Top-Unternehmen",
  ats_title: "ATS-Filter mit KI bestehen",
  ats_sub:
    "Wir scannen Ihren CV genauso wie ein Bewerbermanagementsystem (ATS) und helfen Ihnen dann, ihn so zu verbessern, dass echte Recruiter ihn sehen.",

  ats_item1_title: "Was ist ein ATS?",
  ats_item1_desc:
    "Ein ATS ist eine Software, die Ihren CV prüft, bevor ihn ein Mensch sieht. Sie analysiert Stichwörter, Jobtitel und Grundstruktur, um zu entscheiden, wer weiterkommt.",

  ats_item2_title: "Warum CVs abgelehnt werden",
  ats_item2_desc:
    "Fehlende Schlüsselwörter, unklare Titel, Lücken in den Daten oder überladene Layouts können dazu führen, dass Ihr CV automatisch herausgefiltert wird – selbst wenn Sie gut passen würden.",

  ats_item3_title: "Wie YourSmartCV hilft",
  ats_item3_desc:
    "Wir analysieren Ihren CV, bereinigen die Struktur und fügen die richtigen Stichwörter hinzu, damit ATS-Systeme Sie als starke Besetzung für die Stelle erkennen.",

  ats_item4_title: "Bereit für Recruiter",
  ats_item4_desc:
    "Exportieren Sie einen klaren, recruiter-fertigen PDF-Lebenslauf, der ATS-Checks besteht und sich in Sekunden überfliegen lässt.",

  ats_testimonial_title: "Stimmen unserer Nutzer",
  btn_use_service: "Diesen Service nutzen",

  // About YourSmartCV (second block)

  
  about_brand_name: "YourSmartCV",

  about_intro_1_rest:
    "ist eine Website mit dazugehöriger App, entwickelt von Ly Insights in Berlin, Deutschland. Wir nutzen KI, um jeden Lebenslauf in ein vollständiges, einsatzbereites PDF zu verwandeln, das in HR-Screening-Systemen (ATS) besteht und für Recruiter leicht zu lesen ist.",
  about_intro_2_part1:
    "Egal ob Sie sich auf lokale oder internationale Positionen bewerben, YourSmartCV funktioniert in",
  about_intro_2_languages:
    "fünf Sprachen: Englisch, Französisch, Deutsch, Italienisch und Spanisch",
  about_intro_2_part2:
    "– so können Sie mehr Chancen nutzen, ohne alles von Grund auf neu schreiben zu müssen.",
  about_block_ats_title: "Smart CV Conversion",
  about_block_ats_body:
    "Laden Sie jeden CV als PDF hoch (auch unübersichtlich oder nicht standardisiert) und erhalten Sie einen sauberen, strukturierten Lebenslauf zurück, der HR-Screening-Systeme (ATS) problemlos durchläuft und professionell wirkt.",
  about_block_ai_title: "AI-Enhanced CV Matching",
  about_block_ai_body:
    "Gleichen Sie Ihren CV mit jeder Stellenausschreibung ab und erhöhen Sie Ihre Chancen auf Vorstellungsgespräche. Laden Sie Ihren CV hoch, fügen Sie die Stellenbeschreibung ein und erhalten Sie einen vollständigen, einsatzbereiten CV mit Struktur und Stichwörtern, die auf ATS-Systeme und Recruiter zugeschnitten sind.",
  about_block_builder_title: "Premium CV Builder",
  about_block_builder_body:
    "Starten Sie bei null und lassen Sie unsere KI Ihren CV Schritt für Schritt aufbauen. Stimmen Sie ihn anschließend auf konkrete Stellen ab, um in wenigen Minuten zielgerichtete Versionen zu erstellen – so heben Sie sich ab und sichern sich Ihren nächsten Job.",
  about_block_free_title: "Kostenloser CV-Check",
  about_block_free_body:
    "Laden Sie Ihren CV hoch und sehen Sie sofort, wie gut er in Bewerbermanagementsy stemen (ATS) abschneidet. Wenn Sie einen stärkeren CV möchten, können Sie in wenigen Klicks auf einen der drei kostenpflichtigen Dienste upgraden.",
  about_mission_bold: "Unsere Mission ist einfach:",
  about_mission_rest:
    " professionelle, recruiter-fertige CVs für alle schnell und stressfrei zu machen – an einem Ort und in fünf Sprachen.",
  about_contact_title: "Kontakt:",
  about_contact_email_label: "E-Mail:",
  about_address_title: "Geschäftsadresse:",


  // Services (workspace)
  services_title: "Ihr KI-Arbeitsbereich für CVs",
  services_subtitle:
    "Nutzen Sie die folgenden Tools, um in wenigen Minuten professionelle, recruiter-fertige Lebensläufe zu erstellen.",

  services_ats_desc:
    "Konvertieren Sie jeden CV in ein sauberes, professionelles Format, das Bewerbermanagement systeme (ATS) passiert und für Recruiter gut lesbar ist.",
  services_ai_desc:
    "Gleichen Sie Ihren CV und Ihr Anschreiben mit jeder Stellenausschreibung per KI ab und erhöhen Sie Ihre Chancen auf Interviews.",
  services_builder_desc:
    "Erstellen Sie Ihren CV und Ihr Anschreiben von Grund auf mit KI und generieren Sie sofort professionelle, ausgereifte Versionen.",

  // Free ATS scan result
  ats_result_title: "Ihr CV-Score: {score}% ({level})",
  ats_result_default_reason:
    "Auf diesem Niveau können Bewerbermanagement systeme (ATS) Ihren CV möglicherweise nicht korrekt lesen – das birgt ein hohes Risiko einer automatischen Ablehnung, bevor ein Recruiter ihn sieht.",
  ats_result_boost_cta:
    "Verbessern Sie Ihren CV in wenigen Minuten mit unseren KI-Tools.",
  ats_result_button: "Meinen CV jetzt verbessern",
  ats_level_low: "Niedrig",
  ats_level_medium: "Mittel",
  ats_level_high: "Hoch",

  // Free scan credit
  btn_scan_used: "Kostenloser Scan genutzt",
  free_scan_used:
    "Sie haben Ihren kostenlosen ATS-Scan auf diesem Gerät bereits verwendet. Um weitere CVs zu scannen oder zu verbessern, wählen Sie bitte einen unserer Tarife.",

 

  // ATS score descriptions (hero free scan card)
  ats_desc_low:
    "Die Software, die viele Unternehmen zum Filtern von CVs (ATS) einsetzen, hat Schwierigkeiten, Ihren CV zu lesen. Daher können viele Bewerbungen abgelehnt werden, bevor ein Recruiter sie überhaupt sieht.",
  ats_desc_medium:
    "Die Software, die Unternehmen zur Vorfilterung von CVs (ATS) nutzen, versteht nur Teile Ihres Lebenslaufs – Ihr Profil bleibt daher oft verborgen, statt in Suchen und Shortlists zu erscheinen.",
  ats_desc_high:
    "Die HR-Software zur Bewerberverfolgung (ATS), die viele Arbeitgeber nutzen, kann Ihren CV zwar lesen, aber er ist nicht vollständig in Struktur und Stichwörtern optimiert. Besser optimierte Kandidaten können Sie deshalb bei denselben Stellen überholen.",

  // Blog
  blog_title: "YourSmartCV Karriere-Guides",
  blog_intro:
    "Schritt-für-Schritt-Anleitungen zu ATS, Bewerbungen in Deutschland und CV-Strategie.",
  blog_published_on: "Veröffentlicht",
  blog_read_time: "Lesezeit",
  blog_subtitle:
    "Praxisnahe, ATS-bewusste Tipps, um smartere CVs zu schreiben, Bewerbungen mit KI zu personalisieren und den gewünschten Interviews näherzukommen",
  blog_read_more: "Weiterlesen",
  testimonial_1_text: "Das ist das beste Tool, das ich genutzt habe, um einen professionellen Lebenslauf zu erstellen. Das KI-Matching ist unglaublich genau.",
testimonial_1_author: "Thomas M.",

testimonial_2_text: "Mein CV-Score ist sofort gestiegen. Vorher wurde ich ignoriert, danach bekam ich 4 Vorstellungsgespräche.",
testimonial_2_author: "Sarah M.",

testimonial_3_text: "Endlich ein Tool, das erklärt, was ATS-Systeme wirklich erwarten. Sehr einfach und sehr hilfreich.",
testimonial_3_author: "Daniel K.",
  blog_back: "Zurück zum Blog"
},
it: {


tab_scan: "Analizza gratis il mio curriculum",
tab_match: "Adatta gratis il mio CV a un’offerta di lavoro",
pricing_access_note: "Accesso per 30 giorni • Annulla quando vuoi",
pricing_secure_checkout: "Pagamento sicuro con Stripe. Nessun costo nascosto.",
preview_generating: "Generazione dell’anteprima in corso...",
preview_loading: "Caricamento dell’anteprima...",
preview_error: "Non è stato possibile caricare l’anteprima.",
cta_scan: "Analizza gratis il mio curriculum",
cta_match: "Adatta gratis il mio CV",

hint_secure: "Caricamento sicuro · Elaborazione rapida e automatica",

preview_title: "Anteprima dei tuoi risultati",
preview_sub: "Scopri un CV più chiaro, più efficace e più adatto al lavoro che vuoi ottenere",
preview_no: "La tua anteprima apparirà qui.",
preview_unlock: "Scarica il mio CV",
preview_bottom: "Crea candidature più efficaci con download illimitati di CV e lettere di presentazione.",

video_badge: "Demo di 45 secondi",
video_title: "Scopri come migliorare il tuo CV in meno di un minuto",
video_desc:
  "Carica il tuo CV, ottieni un’analisi ATS, visualizza la versione ottimizzata e scarica subito il tuo CV.",
video_unlock: "Aumenta le tue possibilità",
  // Premium CV Builder contact labels
  builder_contact_title: "Dati di contatto",
  builder_label_name: "Nome",
  builder_label_headline: "Titolo professionale",
  builder_label_email: "E-mail",
  builder_label_phone: "Telefono",
  builder_label_linkedin: "LinkedIn",
  builder_label_location: "Località (città e paese)",
  builder_label_nationality: "Nazionalità",

  // Premium CV Builder add/remove buttons
  builder_add_area: "+ Aggiungi area di competenza",
  builder_add_skill: "+ Aggiungi competenza",
  builder_add_language: "+ Aggiungi lingua",
  builder_add_experience: "+ Aggiungi esperienza",
  builder_add_education: "+ Aggiungi formazione",
  builder_remove_experience: "Rimuovi esperienza",
  builder_remove_education: "Rimuovi formazione",

  // Premium CV Builder – experience & education labels
  builder_exp_role: "Ruolo",
  builder_exp_company: "Azienda",
  builder_exp_location: "Località",
  builder_exp_dates: "Periodo",
  builder_exp_dates_ph: "es. 2019–2024",
  builder_exp_desc: "Descrizione / risultati principali",

  builder_edu_degree: "Titolo di studio / programma",
  builder_edu_institution: "Istituto",
  builder_edu_location: "Località",
  builder_edu_dates: "Periodo",
  builder_edu_dates_ph: "es. 2015–2018",

 
  nav_services: "Servizi",
  nav_pricing: "Prezzi",
  nav_blog: "Blog",
  nav_signin: "Accedi",
  nav_signout: "Esci",

  label_site_lang: "Lingua del sito",
  label_cv_lang: "Lingua del CV",
  label_upload_cv: "Carica il tuo CV (PDF)",
  label_job_desc: "Descrizione dell’offerta",
  label_credits: "Crediti",
  label_quota: "Utilizzati / mese",

  btn_convert: "Converti CV",
  btn_convert_match: "Converti + abbina all’offerta",
  btn_build_from_scratch: "Crea CV",
  btn_download: "Download",

  btn_download_cv: "Scarica CV",
  btn_generate_cover: "Genera la tua lettera di presentazione",
  btn_generate_cover_loading: "Generazione della lettera di presentazione…",
  btn_generate_your_cv: "Genera il tuo CV",

  msg_no_file: "Carica prima un file PDF.",
  msg_no_credits:
    "Non hai più crediti disponibili. Esegui un upgrade o attendi il rinnovo.",
  msg_generated: "Il tuo file è pronto.",
  field_email: "E-mail",
  field_mobile: "Cellulare",
  field_linkedin: "LinkedIn",
  nav_about: "Chi siamo",
  nav_signin: "Accedi",
  nav_signout: "Esci",

  // About
  about_title: "Chi siamo",
  about_paragraph:
    "Siamo CVBuilder Inc., impegnati ad aiutarti a presentare al meglio il tuo profilo professionale. I nostri strumenti basati sull’IA formattano, adattano e creano automaticamente il tuo CV per farti notare.",

  // Services (first block)

  
  services_item1:
    "Conversione CV compatibile con ATS – Trasforma qualsiasi CV in PDF in un file Word ottimizzato per i sistemi di tracciamento delle candidature (ATS).",
  services_item2:
    "AI-Enhanced CV Matching – Adatta le parole chiave e i bullet del tuo CV a qualsiasi annuncio di lavoro.",
  services_item3:
    "CV Builder da zero – Crea un nuovo CV completamente formattato partendo da una pagina bianca.",

  // Pricing
  pricing_title: "Prezzi",
  pricing_loading: "Caricamento del tuo piano…",
  pricing_current_plan: "Il tuo piano attuale:",
  pricing_no_plan: "Nessun piano",
  pricing_active: "(attivo)",
  pricing_inactive: "(non attivo)",
  pricing_manage: "Gestisci abbonamento",
  pricing_col_plan: "Piano",
  pricing_col_conversions: "Conversioni / 30 giorni",
  pricing_col_features: "Funzionalità",
  pricing_col_price: "Prezzo",
  pricing_feat_standard: "Conversioni di CV compatibili con ATS",
  pricing_feat_advanced:
    "Compatibile ATS + matching con IA + miglioramento della job description",
  pricing_feat_premium: "Tutti i servizi (ATS + IA + job description)",
  pricing_subscribe: "Crea il mio CV ora",
  pricing_current: "Attuale",
  feature_ats: "Conversione CV compatibile ATS",
  feature_ai: "AI-Enhanced CV Matching",
  feature_builder: "CV Builder da zero",
  credits_left: "{count} crediti rimanenti",
 credits_none: "Has alcanzado tu límite de uso justo para un uso personal normal. Recarga ahora para continuar al instante.",
  pricing_recharge: "Recargar ahora",
  pricing_cancel_anytime: "Puoi annullare in qualsiasi momento.",
  pricing_fair_use_title: "Fair Use Policy:",
  pricing_fair_use_body:
    "Tutti i piani includono uso illimitato dell’IA per un normale uso personale. Per mantenere il servizio veloce e affidabile per tutti, un utilizzo commerciale intenso o automatizzato può essere limitato temporaneamente.",
  pricing_legal_intro: "Acquistando l’accesso, accetti i nostri",
  pricing_legal_terms: "Termini",
  pricing_legal_and: "e la nostra",
  pricing_legal_privacy: "Privacy Policy",

  // Hero
  hero_title: "Migliora il tuo CV in 30 secondi e ottieni più colloqui",
  hero_sub: "Carica il tuo CV e ricevi subito un controllo gratuito più un’anteprima del tuo CV migliorato.",
  hero_upload_label: "Carica il tuo CV (PDF):",
  btn_scan: "Scansiona il mio CV",
  btn_scanning: "Scansione in corso…",

  per_month: "mese",
  btn_get_started: "Inizia ora",
  badge_gdpr: "CONFORME GDPR",
  badge_secure: "PAGAMENTI SICURI",

  card_ats_title: "Smart CV Conversion",
  card_ats_desc:
    "Converti il tuo CV in un formato che supera i sistemi di tracciamento delle candidature (ATS) ed è facile da leggere per i recruiter.",
  card_ai_title: "AI-Enhanced CV Matching",
  
  card_builder_title: "Premium CV Builder",
  card_ai_desc: "Abbina il tuo CV e la tua lettera di presentazione a qualsiasi offerta di lavoro con l’IA e aumenta le probabilità di ottenere colloqui.",
card_builder_desc: "Crea in pochi minuti un CV e una lettera di presentazione completi e moderni, con l’aiuto dell’IA, per farti distinguere e ottenere il tuo prossimo lavoro.",

  plan_ats_feature1: "Aggiornamento automatico del CV",
  plan_ats_feature2: "Risultati immediati, senza modifiche manuali",
  plan_ats_feature3: "Disponibile in 5 lingue",
  plan_ats_feature4: "Download illimitati",

  plan_ai_feature1: "Aggiornamento automatico del CV",
  plan_ai_feature2: "Matching con la job description tramite IA",
  plan_ai_feature3: "Ottimizzazione delle parole chiave con IA",
  plan_ai_feature4: "Generatore di lettera di presentazione",
  plan_ai_feature5: "Disponibile in 5 lingue",
  plan_ai_feature6: "Download illimitati",

  plan_builder_feature1: "L’IA crea il tuo CV da zero",
  plan_builder_feature2: "Ottimizzato per i sistemi di tracciamento delle candidature",
  plan_builder_feature3: "Matching con la job description tramite IA",
  plan_builder_feature4: "Ottimizzazione delle parole chiave con IA",
  plan_builder_feature5: "Generatore di lettera di presentazione",
  plan_builder_feature6: "Disponibile in 5 lingue",
  plan_builder_feature7: "Download illimitati",

  why_title: "Perché scegliere noi?",
  why_ats_title: "Supera i filtri ATS",
  why_ats_desc:
    "Il tuo CV viene ricostruito per superare i sistemi di tracciamento delle candidature (ATS).",
  why_ai_title: "Matching con IA",
  why_ai_desc:
    "La nostra IA abbina il tuo CV a qualsiasi offerta e aggiunge le competenze giuste.",
  why_easy_title: "Facile da usare",
  why_easy_desc: "Procedura semplice: carica, scansiona e scarica.",
  why_formats_title: "Formati compatibili",
  why_formats_desc:
    "CV professionale, pronto per l’invio in 5 lingue.",

  trusted_by: "Prepara il tuo CV per le aziende più importanti",
  ats_title: "Supera i filtri ATS con l’IA",
  ats_sub:
    "Scansioniamo il tuo CV come farebbe un sistema ATS e poi ti aiutiamo a correggerlo, così che i recruiter possano davvero vederlo.",

  ats_item1_title: "Che cos’è un ATS?",
  ats_item1_desc:
    "Un ATS è il software che controlla il tuo CV prima che lo legga una persona. Analizza parole chiave, titoli di lavoro e struttura di base per decidere chi passa allo step successivo.",

  ats_item2_title: "Perché i CV vengono rifiutati",
  ats_item2_desc:
    "Parole chiave mancanti, titoli poco chiari, buchi temporali o layout troppo complessi possono far sì che il tuo CV venga scartato automaticamente, anche se sei un buon candidato.",

  ats_item3_title: "Come ti aiuta YourSmartCV",
  ats_item3_desc:
    "Analizziamo il tuo CV, puliamo la struttura e aggiungiamo le parole chiave giuste in modo che i sistemi ATS ti riconoscano come un’ottima corrispondenza per il ruolo.",

  ats_item4_title: "Pronto per i recruiter",
  ats_item4_desc:
    "Esporta un PDF pulito, pronto per i recruiter, che supera i controlli ATS ed è facile da leggere in pochi secondi.",

  ats_testimonial_title: "Cosa dicono gli utenti",
  btn_use_service: "Usa questo servizio",

  // About YourSmartCV (second block)

  
  about_brand_name: "YourSmartCV",

  about_intro_1_rest:
    "è un sito web e un’applicazione complementare sviluppati da Ly Insights a Berlino, in Germania. Usiamo l’IA per trasformare qualsiasi CV in un PDF completo e pronto all’uso, che supera i sistemi di screening HR (ATS) ed è facile da leggere per i recruiter.",
  about_intro_2_part1:
    "Che tu stia facendo domanda per posizioni locali o internazionali, YourSmartCV funziona in",
  about_intro_2_languages:
    "cinque lingue: inglese, francese, tedesco, italiano e spagnolo",
  about_intro_2_part2:
    "così puoi raggiungere più opportunità senza dover riscrivere tutto da zero.",
  about_block_ats_title: "Smart CV Conversion",
  about_block_ats_body:
    "Carica qualsiasi CV in PDF (anche disordinato o non standard) e ottieni un CV pulito e strutturato, che passa senza problemi i sistemi di screening HR (ATS) e risulta professionale ai recruiter.",
  about_block_ai_title: "AI-Enhanced CV Matching",
  about_block_ai_body:
    "Abbina il tuo CV a qualsiasi offerta di lavoro e aumenta le tue probabilità di ottenere colloqui. Carica il tuo CV, incolla la job description e ricevi un CV completo e pronto all’uso, con struttura e parole chiave allineate a ciò che cercano ATS e recruiter.",
  about_block_builder_title: "Premium CV Builder",
  about_block_builder_body:
    "Parti da zero e lascia che la nostra IA costruisca il tuo CV passo dopo passo. Poi abbinalo alle singole offerte, creando versioni mirate in pochi minuti – per aiutarti a distinguerti e ottenere il prossimo lavoro.",
  about_block_free_title: "Scansione CV gratuita",
  about_block_free_body:
    "Carica il tuo CV e scopri subito come si comporterebbe nei sistemi ATS. Se vuoi un CV più forte, puoi passare a uno dei tre servizi a pagamento in pochi clic.",
  about_mission_bold: "La nostra missione è semplice:",
  about_mission_rest:
    " rendere i CV professionali e pronti per i recruiter veloci e senza stress per tutti, in un unico posto e in cinque lingue.",
  about_contact_title: "Contatto:",
  about_contact_email_label: "E-mail:",
  about_address_title: "Indirizzo aziendale:",


  // Services (workspace)
  services_title: "Il tuo workspace CV con IA",
  services_subtitle:
    "Usa gli strumenti qui sotto per creare in pochi minuti CV professionali, pronti per i recruiter.",

  services_ats_desc:
    "Converti qualsiasi CV in un formato pulito e professionale che supera i sistemi ATS ed è facile da leggere per i recruiter.",
  services_ai_desc:
    "Abbina il tuo CV e la tua lettera di presentazione a qualsiasi offerta con l’IA e aumenta le tue possibilità di ottenere colloqui.",
  services_builder_desc:
    "Crea il tuo CV e la tua lettera di presentazione da zero con l’IA e genera subito versioni professionali e rifinite.",

  // Free ATS scan result
  ats_result_title: "Punteggio del tuo CV: {score}% ({level})",
  ats_result_default_reason:
    "A questo livello i sistemi ATS potrebbero non leggere correttamente il tuo CV, con un alto rischio di rifiuto automatico prima che un recruiter lo veda.",
  ats_result_boost_cta:
    "Migliora il tuo CV in pochi minuti con i nostri strumenti IA.",
  ats_result_button: "Migliora il mio CV ora",
  ats_level_low: "Basso",
  ats_level_medium: "Medio",
  ats_level_high: "Alto",

  // Free scan credit
  btn_scan_used: "Scansione gratuita utilizzata",
  free_scan_used:
    "Hai già utilizzato la tua scansione ATS gratuita su questo dispositivo. Per scansionare o migliorare altri CV, scegli uno dei nostri piani.",



  // ATS score descriptions (hero free scan card)
  ats_desc_low:
    "Il software che molte aziende usano per filtrare i CV (ATS) fatica a leggere il tuo CV, quindi molte candidature possono essere rifiutate prima che un recruiter le veda.",
  ats_desc_medium:
    "Il software che le aziende usano per pre-filtrare i CV (ATS) comprende solo una parte del tuo CV, quindi il tuo profilo spesso rimane nascosto invece di comparire nelle ricerche e nelle shortlist.",
  ats_desc_high:
    "Il software di tracciamento dei candidati (ATS) utilizzato da molti datori di lavoro può leggere il tuo CV, ma non è completamente ottimizzato in termini di struttura e parole chiave, quindi candidati meglio ottimizzati possono superarti per gli stessi ruoli.",

  // Blog
  blog_title: "YourSmartCV Career Guides",
  blog_intro:
    "Guide passo-passo su ATS, candidature in Germania e strategia del CV.",
  blog_published_on: "Pubblicato",
  blog_read_time: "lettura",
  blog_subtitle:
    "Consigli pratici e attenti agli ATS per scrivere CV più efficaci, adattare le candidature con l’IA e avvicinarti ai colloqui che desideri",
  blog_read_more: "Leggi di più",
  testimonial_1_text: "È il miglior strumento che abbia usato per creare un CV professionale. Il matching con l’IA è incredibilmente preciso.",
testimonial_1_author: "Thomas M.",

testimonial_2_text: "Il punteggio del mio CV è aumentato subito. Prima venivo ignorata, poi ho ottenuto 4 colloqui.",
testimonial_2_author: "Sarah M.",

testimonial_3_text: "Finalmente uno strumento che spiega cosa vogliono i sistemi ATS. Molto semplice e molto utile.",
testimonial_3_author: "Daniel K.",
  blog_back: "Torna al blog"
},
es: {

  tab_scan: "Analizar mi currículum gratis",
tab_match: "Adaptar gratis mi currículum a una oferta",

cta_scan: "Analizar mi currículum gratis",
cta_match: "Adaptar mi currículum gratis",

hint_secure: "Carga segura · Procesamiento rápido y automático",

preview_title: "Vista previa de tus resultados",
preview_sub: "Descubre un currículum más claro, más sólido y mejor adaptado al puesto que buscas",
preview_no: "Tu vista previa aparecerá aquí.",
preview_unlock: "Descargar mi currículum",
preview_bottom: "Crea candidaturas más sólidas con descargas ilimitadas de currículums y cartas de presentación.",

video_badge: "Demo de 45 segundos",
video_title: "Descubre cómo mejorar tu currículum en menos de un minuto",
video_desc:
  "Sube tu currículum, obtén un análisis ATS, revisa la versión optimizada y descarga tu currículum al instante.",
video_unlock: "Impulsa tus oportunidades",
  // Premium CV Builder contact labels
  builder_contact_title: "Datos de contacto",
  builder_label_name: "Nombre",
  builder_label_headline: "Titular profesional",
  builder_label_email: "Correo electrónico",
  builder_label_phone: "Teléfono",
  builder_label_linkedin: "LinkedIn",
  builder_label_location: "Ubicación (ciudad y país)",
  builder_label_nationality: "Nacionalidad",

  // Premium CV Builder add/remove buttons
  builder_add_area: "+ Añadir área de especialización",
  builder_add_skill: "+ Añadir habilidad",
  builder_add_language: "+ Añadir idioma",
  builder_add_experience: "+ Añadir experiencia",
  builder_add_education: "+ Añadir formación",
  builder_remove_experience: "Eliminar experiencia",
  builder_remove_education: "Eliminar formación",

  // Premium CV Builder – experience & education labels
  builder_exp_role: "Puesto",
  builder_exp_company: "Empresa",
  builder_exp_location: "Ubicación",
  builder_exp_dates: "Periodo",
  builder_exp_dates_ph: "p. ej. 2019–2024",
  builder_exp_desc: "Descripción / logros clave",

  builder_edu_degree: "Titulación / programa",
  builder_edu_institution: "Centro educativo",
  builder_edu_location: "Ubicación",
  builder_edu_dates: "Periodo",
  builder_edu_dates_ph: "p. ej. 2015–2018",

  nav_home: "Inicio",
  nav_services: "Servicios",
  nav_pricing: "Precios",
  nav_blog: "Blog",
  nav_signin: "Iniciar sesión",
  nav_signout: "Cerrar sesión",

  label_site_lang: "Idioma del sitio",
  label_cv_lang: "Idioma del CV",
  label_upload_cv: "Sube tu CV (PDF)",
  label_job_desc: "Descripción del puesto",
  label_credits: "Créditos",
  label_quota: "Usados / mes",

  btn_convert: "Convertir CV",
  btn_convert_match: "Convertir + ajustar a la oferta",
  btn_build_from_scratch: "Crear CV",
  btn_download: "Descargar",

  btn_download_cv: "Descargar CV",
  btn_generate_cover: "Generar tu carta de presentación",
  btn_generate_cover_loading: "Generando tu carta de presentación…",
  btn_generate_your_cv: "Generar tu CV",

  msg_no_file: "Primero sube un archivo PDF.",
  msg_no_credits:
    "No te quedan créditos. Mejora tu plan o espera al siguiente ciclo.",
  msg_generated: "Tu archivo está listo.",
  field_email: "Correo electrónico",
  field_mobile: "Móvil",
  field_linkedin: "LinkedIn",
  nav_about: "Sobre nosotros",
  nav_signin: "Iniciar sesión",
  nav_signout: "Cerrar sesión",

  // About
  about_title: "Sobre nosotros",
  about_paragraph:
    "Somos CVBuilder Inc., dedicados a ayudarte a mostrar tu mejor versión profesional. Nuestras herramientas con IA formatean, adaptan y crean tu CV automáticamente para que llame la atención.",

  // Services (first block)

  
  services_item1:
    "Conversión de CV compatible con ATS: convierte cualquier CV en PDF en un archivo Word optimizado para los sistemas de seguimiento de candidatos (ATS).",
  services_item2:
    "AI-Enhanced CV Matching: adapta las palabras clave y los apartados de tu CV a cualquier oferta de empleo.",
  services_item3:
    "Creador de CV desde cero: crea un CV totalmente formateado desde una página en blanco.",

  // Pricing
  pricing_title: "Precios",
  pricing_loading: "Cargando tu plan…",
  pricing_current_plan: "Tu plan actual:",
  pricing_no_plan: "Sin plan",
  pricing_active: "(activo)",
  pricing_inactive: "(inactivo)",
  pricing_manage: "Gestionar suscripción",
  pricing_col_plan: "Plan",
  pricing_col_conversions: "Conversiones / 30 días",
  pricing_col_features: "Funciones",
  pricing_col_price: "Precio",
  pricing_feat_standard: "Conversiones de CV compatibles con ATS",
  pricing_feat_advanced:
    "Compatible con ATS + matching con IA + mejora de la descripción del puesto",
  pricing_feat_premium: "Todos los servicios (ATS + IA + descripción del puesto)",
  pricing_subscribe: "Crear mi CV ahora",
  pricing_current: "Actual",
  feature_ats: "Conversión de CV compatible con ATS",
  feature_ai: "AI-Enhanced CV Matching",
  feature_builder: "Creador de CV desde cero",
  credits_left: "Te quedan {count} créditos",
  credits_none:
    "Has alcanzado el límite de Fair Use para un uso personal normal. Espera a la renovación mensual o cambia a un plan Premium.",
  pricing_cancel_anytime: "Puedes cancelar en cualquier momento.",
  pricing_fair_use_title: "Política de Fair Use:",
  pricing_fair_use_body:
    "Todos los planes incluyen uso ilimitado de IA para un uso personal normal. Para mantener el servicio rápido y estable para todos, el uso comercial intensivo o automatizado puede limitarse temporalmente.",
  pricing_legal_intro: "Al comprar el acceso, aceptas nuestros",
  pricing_legal_terms: "Términos",
  pricing_legal_and: "y la",
  pricing_legal_privacy: "Política de privacidad",

  // Hero
  hero_title: "Mejora tu CV en 30 segundos y consigue más entrevistas",
  hero_sub: "Sube tu CV y recibe un análisis gratuito al instante, además de una vista previa de tu CV mejorado.",
  hero_upload_label: "Sube tu CV (PDF):",
  btn_scan: "Escanear mi CV",
  btn_scanning: "Escaneando…",

  per_month: "mes",
  btn_get_started: "Empezar",
  badge_gdpr: "CUMPLE RGPD",
  badge_secure: "PAGOS SEGUROS",

  card_ats_title: "Smart CV Conversion",
  card_ats_desc:
    "Convierte tu CV a un formato que supera los sistemas de seguimiento de candidatos (ATS) y es fácil de revisar para los reclutadores.",
  card_ai_title: "AI-Enhanced CV Matching",

  card_builder_title: "Premium CV Builder",
 card_ai_desc: "Ajusta tu CV y tu carta de presentación a cualquier oferta de empleo con IA y aumenta tus posibilidades de conseguir entrevistas.",
card_builder_desc: "Crea en pocos minutos un CV y una carta de presentación completos y modernos, impulsados por IA para ayudarte a destacar y conseguir tu próximo trabajo.",


  plan_ats_feature1: "Actualización automática del CV",
  plan_ats_feature2: "Resultados al instante, sin edición manual",
  plan_ats_feature3: "Disponible en 5 idiomas",
  plan_ats_feature4: "Descargas ilimitadas",

  plan_ai_feature1: "Actualización automática del CV",
  plan_ai_feature2: "Matching con la descripción del puesto mediante IA",
  plan_ai_feature3: "Optimización de palabras clave con IA",
  plan_ai_feature4: "Generador de carta de presentación",
  plan_ai_feature5: "Disponible en 5 idiomas",
  plan_ai_feature6: "Descargas ilimitadas",

  plan_builder_feature1: "La IA crea tu CV desde cero",
  plan_builder_feature2:
    "Optimizado para sistemas de seguimiento de candidatos",
  plan_builder_feature3: "Matching con la descripción del puesto mediante IA",
  plan_builder_feature4: "Optimización de palabras clave con IA",
  plan_builder_feature5: "Generador de carta de presentación",
  plan_builder_feature6: "Disponible en 5 idiomas",
  plan_builder_feature7: "Descargas ilimitadas",

  preview_generating: "Generando tu vista previa...",
  preview_loading: "Cargando la vista previa...",
  preview_error: "No se pudo cargar la vista previa.",

  why_title: "Por qué elegirnos?",
  why_ats_title: "Supera los filtros ATS",
  why_ats_desc:
    "Reconstruimos tu CV para que supere los sistemas de seguimiento de candidatos (ATS).",
  why_ai_title: "Matching con IA",
  why_ai_desc:
    "Nuestra IA ajusta tu CV a cualquier oferta y añade las habilidades adecuadas.",
  why_easy_title: "Fácil de usar",
  why_easy_desc: "Proceso sencillo: subir, escanear y descargar.",
  why_formats_title: "Formatos compatibles",
  why_formats_desc:
    "CV profesional, listo para enviar en 5 idiomas.",

  trusted_by: "Prepara tu CV para las mejores empresas",
  ats_title: "Supera los filtros ATS con IA",
  ats_sub:
    "Escaneamos tu CV igual que un sistema ATS y luego te ayudamos a corregirlo para que los reclutadores de verdad lo vean.",

  ats_item1_title: "Qué es un ATS?",
  ats_item1_desc:
    "Un ATS es el software que revisa tu CV antes de que lo vea una persona. Analiza palabras clave, cargos y estructura básica para decidir quién pasa al siguiente paso.",

  ats_item2_title: "Por qué se rechazan los CV",
  ats_item2_desc:
    "La falta de palabras clave, títulos poco claros, huecos en las fechas o diseños demasiado recargados pueden hacer que tu CV se filtre automáticamente, incluso si encajas bien con el puesto.",

  ats_item3_title: "Cómo te ayuda YourSmartCV",
  ats_item3_desc:
    "Analizamos tu CV, limpiamos la estructura y añadimos las palabras clave adecuadas para que los sistemas ATS te vean como un buen candidato para el puesto.",

  ats_item4_title: "Listo para los reclutadores",
  ats_item4_desc:
    "Exporta un PDF limpio, listo para los reclutadores, que supera los controles ATS y se revisa en segundos.",

  ats_testimonial_title: "Qué dicen los usuarios",
  btn_use_service: "Usar este servicio",

  // About YourSmartCV (second block)
  
  
  about_brand_name: "YourSmartCV",

  about_intro_1_rest:
    "es una web y una app complementaria creadas por Ly Insights en Berlín, Alemania. Usamos IA para convertir cualquier CV en un PDF completo y listo para usar que supera los sistemas de filtrado de RR. HH. (ATS) y es fácil de leer para los reclutadores.",
  about_intro_2_part1:
    "Tanto si solicitas puestos locales como internacionales, YourSmartCV funciona en",
  about_intro_2_languages:
    "cinco idiomas: inglés, francés, alemán, italiano y español",
  about_intro_2_part2:
    "para que puedas acceder a más oportunidades sin reescribirlo todo desde cero.",
  about_block_ats_title: "Smart CV Conversion",
  about_block_ats_body:
    "Sube cualquier CV en PDF (incluso desordenado o con formato poco estándar) y recibe un CV limpio y estructurado que pasa sin problemas los sistemas de filtrado de RR. HH. (ATS) y se ve profesional para los reclutadores.",
  about_block_ai_title: "AI-Enhanced CV Matching",
  about_block_ai_body:
    "Ajusta tu CV a cualquier oferta de empleo y aumenta tus opciones de conseguir entrevistas. Sube tu CV, pega la descripción del puesto y recibe un CV completo y listo para usar, con estructura y palabras clave alineadas con lo que buscan los ATS y los reclutadores.",
  about_block_builder_title: "Premium CV Builder",
  about_block_builder_body:
    "Empieza desde cero y deja que nuestra IA construya tu CV paso a paso. Después ajústalo a ofertas concretas para crear versiones específicas en cuestión de minutos y ayudarte a destacar y conseguir tu próximo empleo.",
  about_block_free_title: "Escaneo de CV gratuito",
  about_block_free_body:
    "Sube tu CV y ve al instante cómo se comportaría en los sistemas ATS. Si quieres un CV más fuerte, puedes pasar a uno de nuestros tres servicios de pago en unos pocos clics.",
  about_mission_bold: "Nuestra misión es sencilla:",
  about_mission_rest:
    " hacer que los CV profesionales y listos para los reclutadores sean rápidos y sin estrés para todo el mundo, en un solo lugar y en cinco idiomas.",
  about_contact_title: "Contacto:",
  about_contact_email_label: "Correo electrónico:",
  about_address_title: "Dirección comercial:",


  // Services (workspace)
  services_title: "Tu espacio de trabajo de CV con IA",
  services_subtitle:
    "Usa las herramientas de abajo para crear CV profesionales y listos para los reclutadores en cuestión de minutos.",

  services_ats_desc:
    "Convierte cualquier CV en un formato limpio y profesional que supera los sistemas ATS y es fácil de leer para los reclutadores.",
  services_ai_desc:
    "Ajusta tu CV y tu carta de presentación a cualquier oferta con IA y aumenta tus posibilidades de conseguir entrevistas.",
  services_builder_desc:
    "Crea tu CV y tu carta de presentación desde cero con IA y genera al instante versiones profesionales y refinadas.",

  // Free ATS scan result
  ats_result_title: "Puntuación de tu CV: {score}% ({level})",
  ats_result_default_reason:
    "Con este nivel, los sistemas ATS pueden no leer bien tu CV, lo que implica un alto riesgo de rechazo automático antes de que lo vea un reclutador.",
  ats_result_boost_cta:
    "Mejora tu CV en minutos con nuestras herramientas de IA.",
  ats_result_button: "Mejorar mi CV ahora",
  ats_level_low: "Bajo",
  ats_level_medium: "Medio",
  ats_level_high: "Alto",

  // Free scan credit
  btn_scan_used: "Escaneo gratuito usado",
  free_scan_used:
    "Ya has usado tu escaneo ATS gratuito en este dispositivo. Para escanear o mejorar más CV, elige uno de nuestros planes.",

 

  // ATS score descriptions (hero free scan card)
  ats_desc_low:
    "El software que muchas empresas usan para filtrar CV (ATS) tiene dificultades para leer el tuyo, así que muchas de tus candidaturas pueden ser rechazadas antes de que un reclutador las vea.",
  ats_desc_medium:
    "El software que las empresas usan para prefiltrar CV (ATS) solo entiende parte de tu CV, por lo que tu perfil suele quedar oculto en lugar de aparecer en las búsquedas y shortlists.",
  ats_desc_high:
    "El software de seguimiento de candidatos (ATS) que usan muchos empleadores puede leer tu CV, pero no está totalmente optimizado en estructura y palabras clave, así que candidatos mejor optimizados pueden adelantarte para los mismos puestos.",

  // Blog
  blog_title: "Guías de carrera de YourSmartCV",
  blog_intro:
    "Guías paso a paso sobre ATS, candidaturas en Alemania y estrategia de CV.",
  blog_published_on: "Publicado",
  blog_read_time: "de lectura",
  pricing_access_note: "Acceso durante 30 días • Cancela cuando quieras",
pricing_secure_checkout: "Pago seguro con Stripe. Sin cargos ocultos.",
  blog_subtitle:
    "Consejos prácticos y pensados para ATS que te ayudan a escribir mejores CV, adaptar tus candidaturas con IA y acercarte a las entrevistas que quieres",
  blog_read_more: "Leer más",
  testimonial_1_text: "Es la mejor herramienta que he usado para crear un CV profesional. El matching con IA es increíblemente preciso.",
testimonial_1_author: "Thomas M.",

testimonial_2_text: "Mi puntuación del CV subió al instante. Pasé de ser ignorada a conseguir 4 entrevistas.",
testimonial_2_author: "Sarah M.",

testimonial_3_text: "Por fin una herramienta que explica lo que quieren los sistemas ATS. Muy simple y muy útil.",
testimonial_3_author: "Daniel K.",
  blog_back: "Volver al blog"
}




};

// convenience helper
export const tUI = (lang, key) =>
  (UI_STRINGS[lang] && UI_STRINGS[lang][key]) || UI_STRINGS.en[key] || key;
